<template>
  <div id="app">
    <div class="xq_top">
      <img class="img" @click="xqesc" src="../../static/images/esc.png" />
      <p @click="xqesc">{{pickda[pickxb].fh}}</p>
      <span>{{pickda[pickxb].ddxq}}</span>
    </div>
    <div style="width:100%;padding-top: 1.1rem;background: #f7f7f7;"></div>
    <div class="ddh">
      <div class="on" v-if="DeskID!='Food'">{{Foodlist[pickxb].on1}}：{{Desk.Desk}}</div>
      <div class="on">{{pickda[pickxb].ddh}}：{{Desk.SheetID}}</div>
      <div class="on">{{Foodlist[pickxb].on2}}：</div>
      <div>
        <span>{{MoneySymbol}}</span>
        <span style="font-size:0.60rem;">{{ReMoney.toLocaleString()}}</span>
      </div>
    </div>
    <div style="width:90%;margin:.5rem auto;font-size:.28rem;text-align:left;color:#333;">
      <div style="color:#000;font-weight:bold;font-size:.32rem;">{{Foodlist[pickxb].on3}}</div>
      <div style="margin-top:.2rem;">{{pickda[pickxb].xdsj}}：{{list[list.length-1].MoneyOpItemsTime}}</div>
      <div>{{Foodlist[pickxb].on4}}：{{Desk.MenQua}}</div>
      <div>{{Foodlist[pickxb].on5}}：{{(ReMoney/Desk.MenQua).toLocaleString()}}</div>
    </div>

    <div class="butt">
      <div class="spxx">{{pickda[pickxb].spxx}}</div>
      <div style="width:100%;background: #f7f7f7;height: .04rem;"></div>
      <div class="clas"  v-if="IsBuffet">
        <div class="rigth">
          <div style="display:flex;justify-content:space-between;">
            <div>
              <span>
                <template v-if="WXLangGoodsxb==0">{{items.Goods}}</template>
                <template v-if="WXLangGoodsxb==1">{{items.TwoGoods}}</template>
                <template v-if="WXLangGoodsxb==2">{{items.ThreeGoods}}</template>
              </span>
              <span style="color:#999;">×</span>
              <span style="color:#000;">{{Math.round(Desk.ReMoney/Desk.AaMoney)}}</span>
            </div>
            <div><span style="color:#000;">{{(Math.round(Desk.ReMoney/Desk.AaMoney)*items.MessyPrice).toLocaleString()}}</span></div>
          </div>
        </div>
      </div>
      <template v-for="(item,index) in list" >
        <div class="clas">
          <!--<div class="left">
            <img @error="imageLoad2(index)" ref="xqimg" :src="$lujin+'/Data/'+ShopID+'/GoodsPic/'+item.GoodsID+'.jpg'" />
          </div>-->
          <div class="rigth">

            <div style="display:flex;justify-content:space-between;">
              <div>
                <span>
                  <template v-if="WXLangGoodsxb==0">{{item.Goods}}</template>
                  <template v-if="WXLangGoodsxb==1">{{item.TwoGoods}}</template>
                  <template v-if="WXLangGoodsxb==2">{{item.ThreeGoods}}</template>
                </span>
                <span style="color:#999;">×</span>
                <span style="color:#000;">{{item.Qua}}</span>
              </div>
              <!--<div style="font-size:.24rem;">{{pickda[pickxb].bz}}：{{item.CustomReamrk}}</div>-->
              <div  style="width:1rem;">
                <span style="color:#000;">{{item.SellPrice.toLocaleString()}}</span>
              </div>
            </div>
          </div>
        </div>
      </template>

    </div>
    <template >
      <div class="zdytc"  v-show="canzt" ref="bpq">
        <div class="mmmbbq">
           <p>{{cancen}}</p>
        </div>
        <div class="queding" @click="bpq">{{Foodlist[pickxb].on6}}</div>
      </div>
    </template>

  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {
        pickxb: 0,
        sheet:{},
        pickindex:0,
        SheetID: 0,
        DeskID:0,
        ReMoney:0,
        Desk:{ReMoney:0,AaMoney:0},
        Phone:0,
        MoneySymbol:"",
        cancen:"",
        canzt:false,
        ShopID: 0,
        WXLangGoodsxb:0,
        list: [{
          SheetID: 0,
          GoodsID: 1001,
          SellPrice: 0,
          OpItemsTime:"00:00"
        }],
        pickda:[
          {fh:"返回",ddxq:"结账单",xdsj:"下单时间",ddh:"订单号",spxx:'商品信息',bz:'备注'},
          {fh:"返回",ddxq:"結賬單",xdsj:"下單時間",ddh:"訂單號",spxx:'菜品信息',bz:'備註'},
          {fh:"Back",ddxq:"statement",xdsj:"Place the order of time",ddh:"The order number",spxx:'Commodity information',bz:'note'},
          {fh:"إرجاع",ddxq:"تفاصيل الطلب",xdsj:"وقت الطلب",ddh:"رقم الطلب",spxx:'معلومات المنتج',bz:'ملاحظة'},
          {fh:"ដកថយ",ddxq:"ព័ត៌មានលម្អិត",xdsj:"ពេលវេលាបញ្ជា",ddh:"លេខ​លំដាប់",spxx:'ព័ត៌មាន​អំពី​ផលិតផល',bz:'ចំណាំ'},
          {fh:"Volver",ddxq:"Pedidos",xdsj:"Hora del pedido",ddh:"No. de pedido",spxx:'Detalles del producto',bz:'note'},
          {fh:"return",ddxq:"statement",xdsj:"Place the order of time",ddh:"The order number",spxx:'Commodity information',bz:'note'},
          {fh:"Terug",ddxq:"Bestel statement",xdsj:"Bestel tijd",ddh:"Bestelling nummer",spxx:'Productstatement',bz:'Opmerking'},
          {fh:"Retour",ddxq:"Paiement",xdsj:"Heure de la commande",ddh:"Numéro de commande",spxx:"Informations sur le produit",bz:"Remarques"},
          {fh:"return",ddxq:"dettagli dell'ordine",xdsj:"dettagli dell'ordine",ddh:"numero d'ordine",spxx:'Informazioni sui prodotti',bz:'Nota'},
          {fh:"戻る",ddxq:"お会計",xdsj:"注文時間",ddh:"伝票番号",spxx:'注文内訳',bz:'備考'},
          {fh:"return",ddxq:"statement",xdsj:"Place the order of time",ddh:"The order number",spxx:'Commodity information',bz:'note'},
          {fh:"return",ddxq:"statement",xdsj:"Place the order of time",ddh:"The order number",spxx:'Commodity information',bz:'note'},
          {fh:"Zurück",ddxq:"Kasse",xdsj:"Bestellzeit",ddh:"Bestellnummer",spxx:'Produktinformationen',bz:'Bemerkung'},
          {fh:"return",ddxq:"statement",xdsj:"Place the order of time",ddh:"The order number",spxx:'Commodity information',bz:'note'},
          {fh:"return",ddxq:"statement",xdsj:"Place the order of time",ddh:"The order number",spxx:'Commodity information',bz:'note'},
          {fh:"return",ddxq:"statement",xdsj:"Place the order of time",ddh:"The order number",spxx:'Commodity information',bz:'note'},
          {fh:"return",ddxq:"statement",xdsj:"Place the order of time",ddh:"The order number",spxx:'Commodity information',bz:'note'},
          {fh:"wrócić",ddxq:"zamówienia",xdsj:"Czas na złożenie zamówienia",ddh:"Numer zamówienia",spxx:'Informacje o produkcie',bz:'uwaga'},
          {fh:"return",ddxq:"statement",xdsj:"Place the order of time",ddh:"The order number",spxx:'Commodity information',bz:'note'},
          {fh:"Kembali",ddxq:"Checkout",xdsj:"Waktu pemesanan",ddh:"Nomor pesanan",spxx:'Informasi produk',bz:'Keterangan'},
          {fh:"กลับ",ddxq:"ชำระเงิน",xdsj:"เวลาสั่ง",ddh:"หมายเลขคำสั่งซื้อ",spxx:'ข้อมูลผลิตภัณฑ์',bz:'หมายเหตุ'},
          {fh:"απόδοση",ddxq:"Αποχώρηση",xdsj:"Ώρα παραγγελίας",ddh:"Αριθμός παραγγελίας",spxx:'Πληροφορίες προϊόντος',bz:'Παρατήρηση'},
          {fh:"Nazaj",ddxq:"Podrobnosti o naročilu",xdsj:"Čas naročila",ddh:"Številka naročila",spxx:'Informacije o izdelku',bz:'Opomba'},
          {fh:"Back",ddxq:"statement",xdsj:"Order time",ddh:"Order number",spxx:'Commodity information',bz:'remark'},
		  {fh:"qayıtmaq",ddxq:"Kassa",xdsj:"Sifariş vaxtı",ddh:"Sifariş nömrəsi",spxx:'Məhsul Məlumatı',bz:'Qeyd'},
		  {fh:"ပြန်လည်",ddxq:"စာရင်းချုပ်",xdsj:"စာရင်းချိန်",ddh:"စာရင်းနံပါတ်",spxx:'ကုန်ပစ္စည်းသတင်းအချက်အလက်',bz:'မှတ်ချက်'},
		  {fh:"geri dön",ddxq:"hesap",xdsj:"sipariş zamanı",ddh:"sipariş numarası",spxx:'ürün bilgisi',bz:'not'},
		  {fh:"буцах",ddxq:"Төлбөр тооцоо",xdsj:"Захиалсан цаг",ddh:"Захиалгын дугаар",spxx:"Бүтээгдэхүүний мэдээ",bz:"Тайлбар"},
        ],
        Foodlist:[
          {on1:"台号",on2:"预计应收",on3:"明细",on4:"人数",on5:"预计人均",on6:"确定",on7:"请下单后查看"},
          {on1:"台號",on2:"預計應收",on3:"明細",on4:"人數",on5:"預計人均",on6:"確定",on7:"請下單後查看"},
          {on1:"Desk",on2:"Receivable",on3:"Detailed",on4:"Number of people",on5:"Per capita",on6:"Determine",on7:"Please check after placing the order"},
          {on1:"台号",on2:"预计应收",on3:"明细",on4:"人数",on5:"预计人均",on6:"确定",on7:"请下单后查看"},
          {on1:"台号",on2:"预计应收",on3:"明细",on4:"人数",on5:"预计人均",on6:"确定",on7:"请下单后查看"},
          {on1:"Número de estación",on2:"Créditos previstos",on3:"Detalles",on4:"Número de personas",on5:"Se espera que per cápita",on6:"Determinar",on7:"Por favor, haga un pedido y vea."},
          {on1:"台号",on2:"预计应收",on3:"明细",on4:"人数",on5:"预计人均",on6:"确定",on7:"请下单后查看"},
          {on1:"T",on2:"prijs",on3:"detail",on4:"Aantal personen",on5:"Per persoon",on6:"goed",on7:"Controleer na het plaatsen van de bestelling"},
          {on1:"Numéro de station",on2:"Créances attendues",on3:"Détails",on4:"Nombre de personnes",on5:"Moyenne attendue par habitant",on6:"Confirmer",on7:"Veuillez vérifier après avoir passé la commande"},
          {on1:"台号",on2:"预计应收",on3:"明细",on4:"人数",on5:"预计人均",on6:"确定",on7:"请下单后查看"},
          {on1:"テーブル番号",on2:"合計(税込)",on3:"詳細",on4:"ご利用人数",on5:"割り勘",on6:"確定",on7:"データがありません"},
          {on1:"台号",on2:"预计应收",on3:"明细",on4:"人数",on5:"预计人均",on6:"确定",on7:"请下单后查看"},
          {on1:"台号",on2:"预计应收",on3:"明细",on4:"人数",on5:"预计人均",on6:"确定",on7:"请下单后查看"},
          {on1:"Station Nr.",on2:"Voraussichtlicher Erl?s",on3:"Aufschlüsselung",on4:"Personenzahl",on5:"Voraussichtlicher Pro-Kopf-Betrag",on6:"Best?tigen",on7:"Bitte nach Bestellung einsehen"},
          {on1:"台号",on2:"预计应收",on3:"明细",on4:"人数",on5:"预计人均",on6:"确定",on7:"请下单后查看"},
          {on1:"台号",on2:"预计应收",on3:"明细",on4:"人数",on5:"预计人均",on6:"确定",on7:"请下单后查看"},
          {on1:"台号",on2:"预计应收",on3:"明细",on4:"人数",on5:"预计人均",on6:"确定",on7:"请下单后查看"},
          {on1:"台号",on2:"预计应收",on3:"明细",on4:"人数",on5:"预计人均",on6:"确定",on7:"请下单后查看"},
          {on1:"台号",on2:"预计应收",on3:"明细",on4:"人数",on5:"预计人均",on6:"确定",on7:"请下单后查看"},
          {on1:"台号",on2:"预计应收",on3:"明细",on4:"人数",on5:"预计人均",on6:"确定",on7:"请下单后查看"},
          {on1:"Nomor stasiun",on2:"Perkiraan piutang",on3:"Rincian",on4:"Jumlah orang",on5:"Perkiraan per kapita",on6:"Konfirmasi",on7:"Silakan periksa setelah penempatan pesanan" },
          {on1:"หมายเลขสถานี",on2:"ประมาณการลูกหนี้",on3:"รายละเอียด",on4:"จำนวนคน",on5:"ประมาณการต่อหัว",on6:"แน่นอน",on7:"กรุณาตรวจสอบหลังจากทำการสั่งซื้อ"},
          {on1:"Αριθμός σταθμού",on2:"Εκτιμώμενες απαιτήσεις",on3:"Καθέκαστα",on4:"Αριθμός ατόμων",on5:"Εκτιμώμενο κατά κεφαλήν",on6:"Σίγουρος",on7:"Ελέγξτε μετά την τοποθέτηση της παραγγελίας"},
          {on1:"postaja št.",on2:"Ocenjene terjatve",on3:"Podrobnosti",on4:"Oseba(-e)",on5:"Predvideno na prebivalca",on6:"OK",on7:"Prosimo, preverite po naročilu."},
          {on1:"Station number",on2:"Estimated receivable",on3:"detail",on4:"Person(s)",on5:"Projected Per Capita",on6:"OK",on7:"Please check after ordering."},
          {on1:"Platforma nömrəsi",on2:"Gözlənilən debitor borcları",on3:"Təfərrüatlar",on4:"İnsanların sayı",on5:"Adambaşına düşən gözlənilən",on6:"Əlbəttə",on7:"Sifariş verdikdən sonra yoxlayın."},
		  {on1:"စာရင်းနံပါတ်",on2:"မျှော်မှန်းထားသော တောင်းခံမှု",on3: "အသေးစိတ်", on4: "လူအရေအတွက်",on5: "တစ်ဦးချင်းစီမျှော်မှန်းထားသော တောင်းခံမှု",on6: "အဆင်ပြေသည်",on7:""},
		  {on1:"masa no",on2:"beklenen tahsil",on3:"ayrıntı",on4:"kişi sayısı",on5:"beklenen kişi başına",on6:"onayla",on7:"sipariş verdiğinizde kontrol edebilirsiniz"},
		  {on1:"Хоолны ширээ захиал",on2:"Хүлээгдэж буй авлага",on3:"Дэлгэрэнгүй мэдээлэл",on4:"Хүмүүсийн тоо",on5:"Нэг хүнд ногдох тооц",on6:"Тэгэлгүй яахав",on7:"Захиалгаа өгсний дараа шалгана уу."},
		],
        items:{},
        IsBuffet:0
      }
    },
    mounted() {
      var that = this
      if (localStorage.getItem(this.$route.query.ShopID+'pickxb'))
        this.pickxb = localStorage.getItem(this.$route.query.ShopID+'pickxb');
      if(localStorage.getItem(this.$route.query.ShopID+'pickindex'))//判断语音下标
        this.pickindex=localStorage.getItem(this.$route.query.ShopID+'pickindex')
      const shopId = this.$route.query.ShopID || this.$route.query.Shopid
      if(localStorage.getItem(shopId+'WXLangGoodsxb'))
        this.WXLangGoodsxb=localStorage.getItem(shopId+'WXLangGoodsxb')
      this.ShopID = shopId
      this.DeskID = this.$route.query.DeskID
      this.Phone = this.$route.query.Phone
      this.axios.get(this.$lujin + "/api/Default/PushOrderItems?DeskID=" + this.DeskID + "&ShopID=" + this.ShopID)
        .then((res) => {
          console.log(res)
          if(res.data.State){
            var OrderNumber=res.data.OrderNumber
            var timexb=0
            var ordertime=setInterval(()=>{
              timexb++;
              if(timexb>=20){
                clearInterval(ordertime)
              }
              that.axios.get(that.$lujin + "/api/Default/GetOrderItems?DeskID=" + that.DeskID + "&ShopID=" + that.ShopID+"&OrderNumber="+OrderNumber)
              .then((bpq) => {
                console.log(bpq.data)
                if(bpq.data.State){
                  clearInterval(ordertime)
                  var sz = bpq.data.Data
                  var ReMoney=0
                  for (var i in sz) {
                    ReMoney+=sz[i].Money
                    sz[i].MoneyOpItemsTime = sz[i].OpItemsTime.replace('T', ' ');
                  }
                  that.ReMoney=ReMoney
                  that.list = sz
                }
              })
            },1000)
          }
      })
      this.axios.post(that.$lujin+"/api/Default/Parameter?ShopID="+this.$route.query.ShopID).then((res)=>{
        //console.log(JSON.parse(res.data).Table[0].MoneySymbol)
        that.MoneySymbol=res.data.data[0].MoneySymbol
        that.Shop=res.data.data[0].Shop
      })
      this.axios.get(this.$lujin + "/api/Default/cha_zuo?ShopID=" + this.$route.query.ShopID + "&DeskID=" + this.$route.query.DeskID)
        .then((res) => {
          console.log(res)
          console.log(res.data.data[0])
          that.Desk = res.data.data[0]
          var Desk = res.data.data[0]
          if(Desk.SheetID=="0"||Desk.SheetID==""){
            console.log(12312312312)
            that.cancen=that.Foodlist[that.pickxb].on7
            that.canzt=true
          }
      })
      return
      this.axios.get(this.$lujin + "/api/Default/GetFGoods?DeskID=" + this.$route.query.DeskID + "&ShopID=" + this.$route.query.ShopID).then((res)=>{
        console.log(res)
        console.log(JSON.parse(res.data.Items).Table[0])
        if(res.data.State){
          that.IsBuffet=res.data.IsBuffet
          that.items=JSON.parse(res.data.Items).Table[0]
        }
      })
    },
    methods: {
      bpq:function(){
        this.$router.go(-1)
      },
      imageLoad2(index) {
        this.$refs.xqimg[index].src = '../static/images/zwtp.png'
      },
      xqesc: function() {
        this.$router.go(-1)
      },
    },
  }
</script>



<style scoped>
  .ddh .posers{width:100%;}
  .ddh .on{font-weight: bold;}
  .clas {
    border-bottom: 2px solid #f7f7f7;
  }

  .rigth {
    margin: .06rem 0 0 .2rem;
    text-align: left;
    align-items: center;
    text-align: left;
    text-justify: newspaper;
    word-break: break-all;
  }

  .clas {
    width:90%;
    margin:.3rem auto;
    /*display: flex;*/
  }

  .spxx {
    text-align: left;
    width: 90%;
    margin: 0 auto;
    line-height: 1rem;
  }

  .butt {
    font-size: .32rem;
    font-weight: bold;
  }

  .left img {
    margin: .26rem 0 0 .26rem;
    width: 3rem;
    position: relative;
  }

  .ddh {
    background: url("/static/images/beijingje.png")no-repeat;
    background-size:100% 100%;
    height:2.8rem;
    width:90%;
    margin:0 auto;
    padding: .1rem 0 .1rem 0;
  }

  .ddh div {
    width: 90%;
    margin: 0 auto;
    text-align: left;
    line-height:.64rem;
    font-size:.3rem;
    font-weight:100;
    color:#fff;
  }

  .clear::after {
    content: ;
    clear: both;
  }

  .dingdan {
    background: #fff;
    position: fixed;
    top: .91rem;
    left: 0;
    right: 0;
  }

  .dingdan ul {
    display: flex;
  }

  .dingdan ul li {
    font-size: .32rem;
    width: 25%;
    padding: .1rem;
  }

  .dingdan ul li.on {
    color: orange;
    border-bottom: 1px solid orange;
  }

  .ddlist {
    background: #f7f7f7;
    float: left;
    width: 100%;
    height: 100%;
    padding-top: 1.64rem;
  }

  .ddlist>div {
    width: 90%;
    margin: .3rem auto 0 auto;
    background: #fff;
    border-radius: .1rem;
  }

  .ddlist>div .top p {
    height: .4rem;
    margin-top: .2rem;
    border-radius: .4rem;
    padding: 0 .1rem;
  }

  .ddlist>div .top p.on1 {
    border: 1px solid chartreuse;
    color: chartreuse;
  }

  .ddlist>div .top p.on2 {
    border: 1px solid orange;
    color: orange;
  }

  .ddlist>div .top p.on3 {
    border: 1px solid #999;
    color: #999;
  }

  .ddlist>div .top span {
    line-height: .8rem;
  }

  .ddlist>div .top {
    display: flex;
    justify-content: space-between;
    width: 90%;
    margin: 0 auto;
    height: .8rem;
    border-bottom: 1px solid #eee;
  }

  .ddlist div span,
  .ddlist div p {
    font-size: .28rem;
    display: block;
  }

  .butlist {
    display: flex;
    line-height: .8rem;
    width: 90%;
    margin: 0 auto;
    justify-content: space-between;
  }

  .butlist span {
    font-size: .32rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Qua.vue